import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../_guards/index';

import { UsersComponent } from './users.component'; 
import { ViewuserComponent } from './viewuser.component'; 
import { AgencyComponent } from './agency.component';  
import { ViewagencyComponent } from './viewagency.component'; 
import { RepoagencyComponent } from './repoagency.component'; 

import { AddComponent } from './add.component';

import { EditComponent } from './edit.component';

import { MyaccountComponent } from './myaccount.component';

const routes: Routes = [
  {
    path: '',
    data: {
      title: 'Users'
    }, 
    canActivate: [AuthGuard],
    children: [ 
      {
        path: 'edit/:id',
        component: EditComponent,
        data: {
          title: 'Edit User'
        }
      },
      {
        path: 'users',
        component: UsersComponent,
        data: {
          title: 'Users'
        }
      },
      {
        path: 'agency',
        component: AgencyComponent,
        data: {
          title: 'Agency Users'
        }
      },
      {
        path: 'viewuser/:id',
        component: ViewuserComponent,
        data: {
          title: 'View User'
        }
      },
      {
        path: 'viewagency/:id',
        component: ViewagencyComponent,
        data: {
          title: 'View User'
        }
      },
      {
        path: 'repoagency',
        component: RepoagencyComponent,
        data: {
          title: 'Repo Agency'
        }
      },
      {
        path: 'add',
        component: AddComponent,
        data: {
          title: 'Add User'
        }
      },
      {
        path: 'myaccount',
        component: MyaccountComponent,
        data: {
          title: 'My Account'
        }
      },
    ] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsersRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/users/users-routing.module.ts